import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { UserProfile } from 'src/app/core/models/user';
import { GDPRService } from 'src/app/core/services/rulebook';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { Policies } from 'src/app/core/models/rulebook/policies';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { KeywordModal } from 'src/app/core/models/rulebook/keyword-modal';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { DescriptionData } from 'src/app/core/models/rulebook/description-data';
import { BulkRulebookData } from 'src/app/core/models/rulebook/bulk-rulebook-data';
import { RuleAnalytic, RuleAnalyticData } from 'src/app/core/models/rulebook/rule-analytic-data-model';
import { KeywordDataList, KeywordItem, ModalAnalysisData } from 'src/app/core/models/rulebook/keyword-item';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
//import * as customBuild from './../../../../ckCustomeBuild/build/ckeditor';

@Component({
  selector: 'app-bulk-rule-analytic',
  templateUrl: './bulk-rule-analytic.component.html',
  styleUrls: ['./bulk-rule-analytic.component.scss']
})
export class BulkRuleAnalyticComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  currentId = 0;
  user: UserProfile;
  policyData: Array<Policies>;
  policies: Array<string>;
  section1: Array<string>;
  section2: Array<string>;
  keywordSearch: KeywordModal;
  isLoading = false;
  isRuleSaveLoading = false;
  isModalReq = false;
  modalRequirement: Array<ModalAnalysisData>;
  keySearchText = '';
  policySearchText = '';
  descriptionData: Array<DescriptionData>;
  highlightedText = '';
  sortedOneWord: Array<string> = [];
  sortedTwoWord: Array<string> = [];
  sortedMapCustomKeys: Array<string> = [];
  toastModel: ToastViewModel;
  isToastShow = false;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  ruleAnalyticData: RuleAnalyticData;
  allOneWords: Array<KeywordItem>;
  allTwoWords: Array<KeywordItem>;
  keywordData: KeywordDataList;
  ruleAnalyticList: Array<RuleAnalytic>;
  selectedRuleAnalytic: RuleAnalytic;
  endIndex = 0;
  totalCount = 0;
  isKeyAlgo = false;
  selectedObligation: Array<ModalAnalysisData>;
  isExpanded = false;
  isRuleCopyLoading = false;
  //public Editor = customBuild;

  constructor(
    private gdprService: GDPRService, private dialogRef: MatDialogRef<BulkRuleAnalyticComponent>,
    @Inject(MAT_DIALOG_DATA) public bulkRuleData: BulkRulebookData, private sessionService: SessionService,
    public sanitizer: DomSanitizer) {

    this.user = new UserProfile();
    this.policyData = [];
    this.policies = [];
    this.section1 = [];
    this.section2 = [];
    this.modalRequirement = [];
    this.keywordSearch = new KeywordModal();
    this.ruleAnalyticData = new RuleAnalyticData();
    this.allOneWords = [];
    this.allTwoWords = [];
    this.keywordData = new KeywordDataList();
    this.ruleAnalyticList = [];
    this.selectedRuleAnalytic = new RuleAnalytic();
    this.selectedObligation = [];
    this.descriptionData = [];
    this.toastModel = new ToastViewModel();
  }

  ngOnInit(): void {
    this.getUserProfile();
    this.fetchPolicies();
    this.getRuleAnalytic();
    this.arrangeDescription();
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
    });
  }

  arrangeDescription(): void {
    if (this.bulkRuleData) {
      this.descriptionData = [];
      this.bulkRuleData.rulebooks.forEach(element => {
        const descData = new DescriptionData();
        descData.firstText += '<p class="highlight-para">' + element.regulator;
        if (element.title) {
          descData.firstText += ' => ' + element.title;
        }
        if (element.title1) {
          descData.firstText += ' => ' + element.title1;
        }
        if (element.title2) {
          descData.firstText += ' => ' + element.title2;
        }
        if (element.title3) {
          descData.firstText += ' => ' + element.title3;
        }
        if (element.title4) {
          descData.firstText += ' => ' + element.title4;
        }
        if (element.title5) {
          descData.firstText += ' => ' + element.title5;
        }
        if (element.ruleId) {
          descData.firstText += ' => ' + element.ruleId;
        }
        descData.firstText += '</p>';
        descData.secondText = element.regulatorRuleFullRequirement;
        this.descriptionData.push(descData);
      });
    }
  }

  eventHandler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  // Rule Analytics
  addKeys(event: MatChipInputEvent): void {
    const value = event.value;

    if ((value || '').trim()) {
      this.ruleAnalyticData.mapCustomKeys.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeKeys(type: string): void {
    const index = this.ruleAnalyticData.mapCustomKeys.indexOf(type);

    if (index >= 0) {
      this.ruleAnalyticData.mapCustomKeys.splice(index, 1);
    }
  }

  addGaps(event: MatChipInputEvent): void {
    const value = event.value;

    if ((value || '').trim()) {
      this.ruleAnalyticData.gaps.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeGaps(type: string): void {
    const index = this.ruleAnalyticData.gaps.indexOf(type);

    if (index >= 0) {
      this.ruleAnalyticData.gaps.splice(index, 1);
    }
  }

  addComments(event: MatChipInputEvent): void {
    const value = event.value;

    if ((value || '').trim()) {
      this.ruleAnalyticData.comments.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeComments(type: string): void {
    const index = this.ruleAnalyticData.comments.indexOf(type);

    if (index >= 0) {
      this.ruleAnalyticData.comments.splice(index, 1);
    }
  }

  fetchPolicies(): void {
    this.policies = [];
    this.gdprService.getRulebookPolicies(this.policySearchText).subscribe((result: Array<Policies>) => {
      if (result) {
        this.policyData = result;
        this.policyData.forEach(element => {
          if (element.name && element.name !== ' ') {
            const index = (this.policies as string[]).indexOf(element.name);
            if (index < 0) {
              this.policies.push(element.name);
            }
          }
        });
        if (this.policies.length > 0) {
          this.ruleAnalyticData.policy = this.policies[0];
          this.getSectionList(this.policies[0]);
        }
      }
    });
  }

  getSectionList(policy: string): void {
    this.section1 = [];
    const filteredData = this.policyData.filter(value => value.name.indexOf(policy) === 0);
    filteredData.forEach(element => {
      const index = (this.section1 as string[]).indexOf(element.section1);
      if (index < 0) {
        this.section1.push(element.section1);
      }
    });
    if (this.section1.length > 0) {
      this.ruleAnalyticData.policySection = this.section1[0];
      this.getSubSectionList(policy, this.section1[0]);
    }
  }

  getSubSectionList(policy: string, section: string): void {
    this.section2 = [];
    const filteredData = this.policyData.filter(
      value => value.name === policy &&
        value.section1 === section);
    filteredData.forEach(element => {
      const index = (this.section2 as string[]).indexOf(element.section2);
      if (index < 0) {
        this.section2.push(element.section2);
      }
    });
    if (this.section2.length > 0) {
      this.ruleAnalyticData.policySubSection = this.section2[0];
    }
  }

  getKeywordsData(filter: string): void {
    this.isLoading = true;
    this.keywordSearch.idList = this.bulkRuleData.rulebookIds;
    this.gdprService.getKeywordData(this.keywordSearch).subscribe((result: KeywordDataList) => {
      this.allOneWords = result.oneWordList;
      this.allTwoWords = result.twoWordList;
      this.keywordData = result;
      if (filter !== 'GO' && this.keywordData && this.keywordData.oneWordList) {
        this.keywordData.oneWordList.forEach(element => {
          this.keywordSearch.keywordList.push(element.keyword);
        });
      }
      if (this.keywordData && this.keywordData.modalAnalysis) {
        this.modalRequirement = this.keywordData.modalAnalysis;
      }
      this.isLoading = false;
    });
  }

  // keyword list for text highlighter script query
  getKeywordList(): void {
    this.keywordSearch.keywordList = [];
    if (this.keywordData) {
      if (this.keywordSearch.keywordType === 'yake') {
        this.keywordData.oneWordList.forEach(element => {
          this.keywordSearch.keywordList.push(element.keyword);
        });
      } else if (this.keywordSearch.keywordType === 'rake') {
        this.keywordData.twoWordList.forEach(element => {
          this.keywordSearch.keywordList.push(element.keyword);
        });
      } else {
        this.keywordSearch.keywordList = [];
      }
    }
  }

  getTextHighlightedData(): void {
    this.isLoading = true;
    this.keywordSearch.id = this.currentId;
    this.gdprService.getHighlightedData(this.keywordSearch).subscribe((data: any) => {
      this.isLoading = false;
      this.isKeyAlgo = true;
      this.highlightedText = data ? data.result : '';
    });
  }

  selectOneWordItem(event: any, text: string): void {
    if (event === 'Checked') {
      this.ruleAnalyticData.oneWordList.push(text);
    } else {
      const index = (this.ruleAnalyticData.oneWordList as string[]).indexOf(text);
      if (index >= 0) {
        (this.ruleAnalyticData.oneWordList as string[]).splice(index, 1);
      }
    }
  }

  selectTwoWordItem(event: any, text: string): void {
    if (event === 'Checked') {
      this.ruleAnalyticData.twoWordList.push(text);
    } else {
      const index = (this.ruleAnalyticData.twoWordList as string[]).indexOf(text);
      if (index >= 0) {
        (this.ruleAnalyticData.twoWordList as string[]).splice(index, 1);
      }
    }
  }

  getSelectedItems(text: string, type: string): boolean {
    if (type === 'OneWord') {
      const index = (this.ruleAnalyticData.oneWordList as string[]).indexOf(text);
      return index >= 0 ? true : false;
    } else {
      const index = (this.ruleAnalyticData.twoWordList as string[]).indexOf(text);
      return index >= 0 ? true : false;
    }
  }

  saveRuleAnalytic(): void {
    this.isRuleCopyLoading = true;
    this.ruleAnalyticData.rulebookIdList = this.bulkRuleData.rulebookIds;
    this.ruleAnalyticData.modalRequirements = this.selectedObligation;
    this.gdprService.saveRuleAnalyticData(this.ruleAnalyticData).subscribe(() => {
      this.isModalReq = false;
      this.getRuleAnalytic();
      this.isRuleCopyLoading = false;
    });
  }

  getRuleAnalytic(): void {
    this.gdprService.getRuleAnalyticList(this.bulkRuleData.rulebookIds).subscribe((result: Array<RuleAnalytic>) => {
      this.ruleAnalyticList = result;
      this.totalCount = result.length;
      this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      if (result && result.length > 0) {
        this.changeRuleAnalytic(result[0]);
      } else {
        this.clearRuleAnalyticData();
      }
    });
  }

  removeRuleAnalytic(id: number): void {
    this.isRuleCopyLoading = true;
    this.gdprService.removeRuleAnalytic(id).subscribe((result: any) => {
      this.isRuleCopyLoading = false;
      this.getRuleAnalytic();
    });
  }

  onEnterSearchKeys(event: any, filter: string): void {
    switch (filter) {
      case 'Keyword':
        if (this.keySearchText.length > 1) {
          this.searchKeys(filter);
        } else {
          this.keywordData.oneWordList = this.allOneWords;
          this.keywordData.twoWordList = this.allTwoWords;
        }
        break;
      case 'Policy':
        if (event.keyCode === 13) {
          this.searchKeys(filter);
        }
        break;
    }
  }

  searchKeys(filter: string): void {
    switch (filter) {
      case 'Keyword':
        const searchedResult = Array<KeywordItem>();
        const searchedResult2 = Array<KeywordItem>();
        if (this.keySearchText) {
          this.allOneWords.forEach(yakeElem => {
            if (yakeElem.keyword.toUpperCase().includes(this.keySearchText.toUpperCase())) {
              searchedResult.push(yakeElem);
            }
          });
          this.allTwoWords.forEach(rakeElem => {
            if (rakeElem.keyword.toUpperCase().includes(this.keySearchText.toUpperCase())) {
              searchedResult2.push(rakeElem);
            }
          });
          this.keywordData.oneWordList = searchedResult;
          this.keywordData.twoWordList = searchedResult2;
        } else {
          this.keywordData.oneWordList = this.allOneWords;
          this.keywordData.twoWordList = this.allTwoWords;
        }
        break;
      case 'Policy':
        this.fetchPolicies();
        break;
    }
  }

  selectObligation(event: any, item: ModalAnalysisData): void {
    if (this.selectedRuleAnalytic.id === 0) {
      if (event === 'Checked') {
        this.selectedObligation.push(item);
      } else {
        const index = this.selectedObligation.findIndex(a => a.id === item.id);
        if (index >= 0) {
          (this.selectedObligation as ModalAnalysisData[]).splice(index, 1);
        }
      }
    }
  }

  getSelectedObligations(id: number): boolean {
    if (this.selectedObligation) {
      const index = this.selectedObligation.findIndex(a => a.id === id);
      return index >= 0 ? true : false;
    } else {
      return false;
    }
  }

  changeRuleAnalytic(obj: RuleAnalytic): void {
    if (this.selectedRuleAnalytic.id > 0 && this.selectedRuleAnalytic.id === obj.id) {
      this.clearRuleAnalyticData();
    } else {
      this.getSortedItems(obj);
      this.isExpanded = true;
      this.selectedRuleAnalytic = obj;
      this.ruleAnalyticData.id = obj.id;
      this.ruleAnalyticData.oneWordList = obj.oneWord ? obj.oneWord.split('|') : [];
      this.ruleAnalyticData.twoWordList = obj.twoWord ? obj.twoWord.split('|') : [];
      this.ruleAnalyticData.mapCustomKeys = obj.mapCustomKeys ? obj.mapCustomKeys.split('|') : [];
      this.ruleAnalyticData.gaps = obj.gap ? obj.gap.split('|') : [];
      this.ruleAnalyticData.comments = obj.comment ? obj.comment.split('|') : [];
      this.selectedObligation = [];
      const searchedMR = this.modalRequirement.find(a => a.id === obj.rulebookId);
      if (searchedMR) {
        this.selectedObligation.push(searchedMR);
      }
      this.ruleAnalyticData.policy = obj.policyName;
      this.getSectionList(obj.policyName);
      this.ruleAnalyticData.policySection = obj.policySection;
      this.getSubSectionList(obj.policyName, obj.policySection);
      this.ruleAnalyticData.policySubSection = obj.policySubSection;
    }
  }

  getSortedItems(obj: RuleAnalytic): void {
    this.sortedMapCustomKeys = obj.mapCustomKeys ? obj.mapCustomKeys.split('|') : [];
    this.sortedOneWord = [];
    this.sortedTwoWord = [];
    if (obj.oneWord) {
      obj.oneWord.split('|').forEach(oneWord => {
        if (this.keywordData.oneWordList.some(a => a.keyword === oneWord)) {
          this.sortedOneWord.push(oneWord);
        } else {
          this.sortedMapCustomKeys.push(oneWord);
        }
      });
    }
    if (obj.twoWord) {
      obj.twoWord.split('|').forEach(twoWord => {
        if (this.keywordData.twoWordList.some(a => a.keyword === twoWord)) {
          this.sortedTwoWord.push(twoWord);
        } else {
          this.sortedMapCustomKeys.push(twoWord);
        }
      });
    }
    this.sortedOneWord = MasterHelper.getDistinctValues(this.sortedOneWord);
    this.sortedTwoWord = MasterHelper.getDistinctValues(this.sortedTwoWord);
    this.sortedMapCustomKeys = MasterHelper.getDistinctValues(this.sortedMapCustomKeys);
  }

  clearRuleAnalyticData(): void {
    this.isExpanded = false;
    this.selectedRuleAnalytic = new RuleAnalytic();
    this.ruleAnalyticData.id = 0;
    this.ruleAnalyticData.oneWordList = [];
    this.ruleAnalyticData.twoWordList = [];
    this.ruleAnalyticData.mapCustomKeys = [];
    this.ruleAnalyticData.gaps = [];
    this.ruleAnalyticData.comments = [];
    this.selectedObligation = [];
    if (this.policies.length > 0) {
      this.ruleAnalyticData.policy = this.policies[0];
      this.getSectionList(this.policies[0]);
    }
  }

  copyRuleAnalytic(obj: RuleAnalytic): void {
    this.isRuleCopyLoading = true;
    this.gdprService.duplicateRuleAnalytic(obj).subscribe((result: any) => {
      this.isRuleCopyLoading = false;
      this.getRuleAnalytic();
    });
  }

  saveGapComments(): void {
    if (this.ruleAnalyticData.gaps.length === 0) {
      this.warningAlert('Please specify the gap');
    } else {
      this.isLoading = true;
      this.ruleAnalyticData.mapCustomKeys = [];
      this.ruleAnalyticData.modalRequirements = [];
      this.ruleAnalyticData.oneWordList = [];
      this.ruleAnalyticData.twoWordList = [];
      this.ruleAnalyticData.policy = '';
      this.ruleAnalyticData.policySection = '';
      this.ruleAnalyticData.policySubSection = '';
      this.ruleAnalyticData.rulebookIdList = this.bulkRuleData.rulebookIds;
      this.gdprService.saveRuleAnalyticData(this.ruleAnalyticData).subscribe(() => {
        this.isModalReq = false;
        this.getRuleAnalytic();
        this.isLoading = false;
      });
    }
  }

  warningAlert(text: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = text;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
